module.exports = __webpack_public_path__ + "img/4-ExitusForce.54747426.jpg";